const CreateIcon = () => (
    <svg width="39" height="39" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <path
                d="M21.489 17.511V9.953H17.51v7.558H9.953v3.978h7.558v7.558h3.978v-7.558h7.558V17.51h-7.558zm9.027-1.469v6.916h-7.558v7.558h-6.916v-7.558H8.484v-6.916h7.558V8.484h6.916v7.558h7.558z"
                id="createiconpath"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h39v39H0z" />
            <use fill="#0F9" fillRule="nonzero" xlinkHref="#createiconpath" />
        </g>
    </svg>
)

export default CreateIcon
